import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=2970c2b2&scoped=true&"
import script from "./NotificationBell.vue?vue&type=script&lang=ts&"
export * from "./NotificationBell.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=2970c2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2970c2b2",
  null
  
)

export default component.exports